import 'mobx-react-lite/batchingForReactDom'

/// Import moment locales to make them available later
import 'moment/locale/da'

/// Load the React app module. It will take care of most bootstrapping
import { App } from '@morningtrain/react-app'
import { OperationRepository } from '@morningtrain/react-resources'
import { AuthService } from '@morningtrain/react-auth'
import { SmartviewManager } from '@morningtrain/react-smartviews'
import Toastify from 'services/Toastify'
import { LaravelTranslationService } from '@morningtrain/react-translations'

const app = App.create()

/// Optionally register additional plugins
/// A plugin is a class implementing a boot method
/// The boot method should accept an app instance as a parameter
/// In order to work with boot flow, the method should return a Promise
// app.register(SomePlugin);
console.log(app)

/// Define the services to wrap all pages in
/// It should be a series of react components that all render their children
app.services([
  OperationRepository,
    [AuthService, { reloadPageOnUnauthorized: true }],
  LaravelTranslationService,
  Toastify,
  SmartviewManager,
  require('@morningtrain/react-modals').Repository
])

/// Specify default page template
app.templates(require('templates'))
app.defaultTemplate('Admin')

/// Configure which React components to load into the application
/// Only components included in this object, can be added from Laravel Blade views.
/// It should primarily be the main app page components that are included here

app.setReactComponents('app', {
  Login: require('pages/shared/Login').default,
  ForgotPassword: require('pages/shared/ForgotPassword').default,
  ResetPassword: require('pages/shared/ResetPassword').default,
  Shop: {
    Receipt: require('pages/app/shop/Receipt').default,
    Domains: {
      Index: require('pages/app/shop/domains/Index').default
    },
    Cart: {
      Overview: require('pages/app/shop/cart/Overview').default
    }
  },
  Links: {
    Index: require('pages/app/links/Index').default,
    Edit: require('pages/app/links/Edit').default
  },
  Domains: {
    Index: require('pages/app/domains/Index').default,
    Edit: require('pages/app/domains/Edit').default
  },
  Customers: {
    Index: require('pages/app/customers/Index').default,
    Edit: require('pages/app/customers/Edit').default
  },
  Users: {
    Admins: {
      Index: require('pages/app/users/admins/Index').default,
      Edit: require('pages/app/users/admins/Edit').default
    }
  }
})

/// Boot the application
/// It will loop through all applied plugins and load them in order.
/// After booting all plugins, it will listen to a document ready event
/// When the DOM is ready, it will then mount and render all react components present in the DOM
app.run()
